import React from 'react';
import { HERO_GRADIENT } from '../../constants/brand';

const PageHero = ({ title, subtitle, eyebrow, compact = false }) => (
  <section
    className={`relative overflow-hidden ${compact ? 'py-8 md:py-10' : 'py-10 md:py-12'}`}
    style={{ background: HERO_GRADIENT }}
  >
    <div className="pointer-events-none absolute top-0 right-[15%] w-32 h-32 rounded-full bg-yellow-300/20 blur-2xl" />
    <div className="pointer-events-none absolute bottom-0 left-[10%] w-40 h-40 rounded-full bg-orange-700/15 blur-2xl" />
    <div className="container mx-auto px-4 text-center relative z-10">
      {eyebrow && (
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/75 mb-2">
          {eyebrow}
        </p>
      )}
      <h1 className="text-2xl md:text-3xl font-bold text-white tracking-tight">{title}</h1>
      {subtitle && (
        <p className="text-sm md:text-base text-white/85 mt-2 max-w-lg mx-auto">{subtitle}</p>
      )}
    </div>
  </section>
);

export default PageHero;
